export class LOCALISATIONS {
  static Regions: any[] = [
    { id: 1, name: 'Dakar' },
    { id: 2, name: 'Diourbel' },
    { id: 3, name: 'Fatick' },
    { id: 4, name: 'Kaffrine' },
    { id: 5, name: 'Kaolack' },
    { id: 6, name: 'Kédougou' },
    { id: 7, name: 'Kolda' },
    { id: 8, name: 'Louga' },
    { id: 9, name: 'Matam' },
    { id: 10, name: 'Saint-Louis' },
    { id: 11, name: 'Sédhiou' },
    { id: 12, name: 'Tambacounda' },
    { id: 13, name: 'Thiès' },
    { id: 14, name: 'Ziguinchor' },
    { id: 15, name: 'Hors Sénégal' },
    // { id: 16, name: 'Somone' },
  ];
  static Zones: any[] = [
    { id: 1, name: 'Zone rurale' },
    { id: 2, name: 'Zone urbaine' },
    { id: 3, name: 'Zone péri-urbaine' },
  ];
  static RegionsBenin: any[] = [
    { id: 1, name: 'Alibori' },
    { id: 2, name: 'Atacora' },
    { id: 3, name: 'Atlantique' },
    { id: 4, name: 'Borgou' },
    { id: 5, name: 'Collines' },
    { id: 6, name: 'Couffo' },
    { id: 7, name: 'Donga' },
    { id: 8, name: 'Littoral' },
    { id: 9, name: 'Mono' },
    { id: 10, name: 'Ouémé' },
    { id: 11, name: 'Plateau' },
    { id: 11, name: 'Zou' },
    { id: 12, name: 'Hors Bénin' },
  ];
  static Pays: any[] = [
    { id: 1, name: 'Senegal' },
    { id: 2, name: 'Gambie' },
    { id: 3, name: 'Mali' },
    { id: 4, name: 'Autre' },
  ];
}
